<div class="private-mode">
  <div class="private-mode__logo">
    <img class="p-4" src="./assets/logo-onmat.svg" alt="logo onmat" />
  </div>
  <div class="private-mode__content">
    <div class="private-mode__image">
      <img src="./assets/img/gollum_cookies.png" alt="gollum_cookies" />
    </div>
    <div class="private-mode__message">
      <h4 class="font-bold private-mode__message--big">{{ 'f.private-mode.title' | translate }}</h4>
      <p class="mt-2 font-normal text-2xl">{{ 'f.private-mode.subtitle' | translate }}</p>
    </div>
  </div>
</div>
